<div class="modal-header">
  <h2
    *ngIf="!(booking$ | async)?.courseId"
    [innerHTML]="
      (linkedProduct$ | async)?.id
        | getTranslation: 'product' : 'description'
        | async
        | safeHtml
    "
  ></h2>

  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'wcag.close' | translate }}"
    (click)="cancel()"
  >
  </button>
</div>

<div class="modal-body">
  <div class="row justify-content-between">
    <div class="col-12 col-md-6">
      <div
        class="d-flex align-items-start mb-2"
        *ngIf="(booking$ | async)?.description?.length"
      >
        <i
          class="fa fa-list text-primary me-2 mt-1 fa-fw"
          aria-hidden="true"
          role="img"
        ></i>

        <div class="flex-grow-1">
          {{
            (booking$ | async)?.linkedProductId
              | getTranslation: 'product' : 'description'
              | async
              | stripHtmlTags
          }}
        </div>
      </div>
      <div class="d-flex align-items-start mb-2">
        <i
          class="fa fa-map-marker-alt text-primary me-2 mt-1 fa-fw"
          role="img"
          attr.aria-label="{{ 'wcag.location' | translate }}"
        ></i>
        <div class="flex-grow-1">
          <span *ngIf="product$ | async">
            {{
              (product$ | async)?.id
                | getTranslation: 'product' : 'description'
                | async
                | stripHtmlTags
            }}
            -
            {{
              (locationEntities$ | async)[(product$ | async)?.locationId]
                ?.description
            }}
          </span>
        </div>
      </div>
      <div class="d-flex align-items-start mb-2">
        <i
          class="fa fa-calendar-alt text-primary me-2 mt-1 fa-fw"
          role="img"
          attr.aria-label="{{ 'wcag.date' | translate }}"
        ></i>

        <div class="flex-grow-1">
          {{
            (booking$ | async)?.startDate
              | formatDate: 'EE d MMM y HH:mm'
              | async
          }}
          - {{ (booking$ | async)?.endDate | date: 'HH:mm' | roundMinutes }}
        </div>
      </div>

      <div class="d-flex align-items-start mb-2">
        <show-spots-left
          [showIcon]="true"
          [usePrimaryColor]="true"
          [showTotal]="false"
          [item]="booking$ | async"
          [type]="'booking'"
        >
        </show-spots-left>
      </div>

      <div class="d-flex align-items-start mb-2">
        <i
          class="fa fa-user-tag text-primary me-2 mt-1 fa-fw"
          role="img"
          attr.aria-label="{{ 'wcag.supervisor' | translate }}"
        ></i>
        <div class="flex-grow-1">
          {{ 'myWorkModule.numberOfSupervisors' | translate }}:
          {{ getNumberOfSupervisors$() | async }}
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-label small">
        {{ 'bookingModule.supervisorMemo' | translate }}
      </div>
      <p class="text-break">
        {{ (booking$ | async)?.supervisorMemo }}
      </p>
      <form
        [formGroup]="form"
        [patchForm]="booking$ | async"
        *ngIf="
          (supervisorBooking$ | async)?.status ==
          SupervisorBookingStatus.ACCEPTED
        "
      >
        <label class="form-label" id="registerAmountParticipantsLabel">
          {{ 'bookingModule.registerAmountParticipants' | translate }}
          <i
            class="ms-2 fa fa-question-circle"
            role="button"
            [tooltip]="
              'bookingModule.registerAmountParticipantsTooltip' | translate
            "
            tabindex="0"
          ></i>
        </label>
        <div class="btn-group">
          <input
            class="form-control"
            type="number"
            inputmode="numeric"
            formControlName="totalMembersOnline"
            aria-labelledby="registerAmountParticipantsLabel"
            [attr.aria-invalid]="
              form.controls.totalMembersOnline.dirty &&
              form.controls.totalMembersOnline.invalid
                ? 'true'
                : null
            "
          />
          <button
            class="btn btn-soft-primary"
            type="submit"
            (click)="onSubmit()"
          >
            {{ 'general.save' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <button
    class="btn btn-soft-primary m-3"
    type="button"
    (click)="goToSurveys()"
  >
    {{ 'surveyModule.surveyAnswers' | translate }}
  </button>

  <member-participation-table
    [tableData]="participants$ | async"
  ></member-participation-table>

  <div
    [hidden]="
      (supervisorBooking$ | async)?.status != SupervisorBookingStatus.INVITED &&
      (supervisorBooking$ | async)?.status !=
        SupervisorBookingStatus.ACCEPTED &&
      (supervisorBooking$ | async)?.status != SupervisorBookingStatus.REMINDED
    "
    class="text-center mt-4"
  >
    <button type="button" class="btn btn-primary" (click)="getIcalDownload()">
      <i class="fa fa-calendar-plus me-2" aria-hidden="true" role="img"></i>
      {{ 'bookingModule.addToCalendar' | translate }}
    </button>
  </div>
</div>

<div class="modal-footer justify-content-between">
  <button
    class="btn btn-ghost-primary order-2 order-md-0"
    type="button"
    (click)="cancel()"
  >
    {{ 'general.close' | translate }}
  </button>

  <div
    *ngIf="
      supervisorModuleConfig.allowedStatusesForDeclineInvitation.includes(
        (supervisorBooking$ | async)?.status
      )
    "
    class="d-flex align-items-center"
  >
    <button
      type="button"
      class="btn btn-soft-primary"
      (click)="onClickDecline(false)"
      data-test-id="my-work-bookings-button-decline"
    >
      {{ 'general.decline' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-soft-primary"
      (click)="onClickDecline(true)"
      data-test-id="my-work-bookings-button-decline-and-set-unavailable"
    >
      {{ 'employeeModule.declineAndSetAsUnavailable' | translate }}
    </button>

    <button
      type="button"
      class="btn btn-primary"
      (click)="onClickAccept()"
      data-test-id="my-work-bookings-button-accept"
    >
      {{ 'general.accept' | translate }}
    </button>
  </div>
</div>
